import React, { Component, Fragment } from "react";
import SelectComponent from "../Select";
import { SpaceBox } from "../Space";
import DataService from "../../service/data";
import _ from "lodash";
import { Alert } from "../../utils";

export default class ProvincesOtherComponent extends Component {
  state = {
    provinceList: [],
    districtList: []
  };

  allAddress;

  constructor(props) {
    super(props);
    this.initData();
  }

  async initData() {
    const { sProvinceOther } = this.props.provinces;
    const callers = [];
    callers.push(DataService.getProvinces());

    if (sProvinceOther) {
      callers.push(DataService.getAmphurTumbonZipCode(sProvinceOther));
    }
    try {
      const responses = await Promise.all(callers);
      const provinceList = responses[0].provinces.map(p => { return { value: p.id, label: p.name_th  } })

      if(callers.length > 1) {
          this.allAddress = responses[1];
          this.setAmphur();
          this.setTumbon();
      }
  
      // if (callers.length > 1) {
      //   this.allAddress = responses[1];
      // }
      this.setState({ ...this.state, provinceList });
    }
    catch {

    }

  }

  async onChangeProvince(selected) {
    const { onChange, provinces } = this.props;

    if (provinces.sProvinceOther.value == selected.value) {
      return false;
    }
    onChange({
      sProvinceOther: selected,
      sDistrictOther: "",
      sCityOther: "",
      sZipcodeOther: ""
    });

    //Fetch Amphur
    try {
      Alert.showLoading(); 
      this.allAddress = await DataService.getAmphurTumbonZipCode({ province: selected.label });
      Alert.hideLoading();
      this.setAmphur();
    }
    catch {
        Alert.hideLoading()
    }
  }

  setAmphur() {
    const amphurList = _.intersectionBy(this.allAddress, 'district_id')
    .map(d => { return { value: d.district_id, label: d.district } } )

    this.setState({ ...this.state, amphurList, tumbonList: [] });
  }

  async onChangeDistrict(selected) {
    const { onChange, provinces } = this.props;
    const { sDistrictOther } = provinces;
    if (sDistrictOther.value == selected.value) {
      return false;
    }

    onChange({ sDistrictOther: selected, sCityOther: "", sZipcodeOther: "" });

    setTimeout(()=> this.setTumbon(), 400);

    // let tumbonList = _.filter(this.allAddress, { district_id: selected.value });
    // tumbonList = _.intersectionBy(tumbonList, "sub_district_id").map(d => {
    //   return { value: d.sub_district_id, label: d.sub_district };
    // });

    // this.setState({ ...this.state, tumbonList });
  }

  setTumbon() {
    const { sDistrictOther } = this.props.provinces;
    let tumbonList = _.filter(this.allAddress, { district_id: sDistrictOther.value})
    tumbonList = _.intersectionBy(tumbonList, 'sub_district_id')
                            .map(d => { return { value: d.sub_district_id, label: d.sub_district } } )

    this.setState({ ...this.state, tumbonList });
  }


  async onChangeSubDistrict(selected) {
    const { onChange, provinces } = this.props;
    const { sDistrictOther, sCityOther } = provinces;
    if (sCityOther.value == selected.value) {
      return false;
    }
    let address = _.filter(this.allAddress, {
      district_id: sDistrictOther.value,
      sub_district_id: selected.value
    })[0];
    onChange({ sCityOther: selected, sZipcodeOther: address.zip_code });
  }

  _getLang(field) {
    const { langague, lang } = this.props;
    return langague[field][lang];
  }

  _SpaceBox() {
    return <SpaceBox w={"14px"} />;
  }

  render() {
    const { sProvinceOther, sDistrictOther, sCityOther, sZipcodeOther = "" } =
      this.props.provinces || {};
    const { provinceList, amphurList, tumbonList } = this.state;

    return (
      <Fragment>
        <div className="form-group">
          <SelectComponent
            placeholder={this._getLang("province")}
            options={provinceList}
            selected={sProvinceOther}
            onChange={selected => this.onChangeProvince(selected)}
          />
        </div>
        <div className="form-group">
          <SelectComponent
            placeholder={this._getLang("district")}
            options={amphurList}
            selected={sDistrictOther}
            onChange={selected => this.onChangeDistrict(selected)}
          />
        </div>
        <div className="form-group d-flex">
          <SelectComponent
            placeholder={this._getLang("subDistrict")}
            options={tumbonList}
            selected={sCityOther}
            onChange={selected => this.onChangeSubDistrict(selected)}
            // onChange={selected =>
            //     onChangeOther({ name: "sCityOther", value: selected })
            // }
          />
          {this._SpaceBox()}
          <input
            // id={sProvinceOther}
            type="text"
            className="form-control"
            placeholder={this._getLang("postCode")}
            name="sZipcodeOther"
            readOnly
            disabled
            value={sZipcodeOther}
          />
        </div>
      </Fragment>
    );
  }
}
